{
  "next": "Suivant",
  "previous": "Précédent"
}
